import { createContext } from 'react';
import { SDM } from '@siliconlabs/sdm-schema';
import {
  Anchor,
  ClientDocLeaf,
  ClientDocSpace,
  CollectionItem,
  VersionsHistory,
} from '../types';

// Todo: move me
interface PageContextState {
  isStatic: boolean; // If the page is being generated statically.
  pdfMode: boolean; // If we are in a PDF
  leafPdfExists?: boolean; //If the docLeaf pdf exist 
  spacePdfExists?: boolean; // If the docSpace pdf exists
  relPath: string; // The current relative depth of the html item (for static rendering)
  pathname: string; // The current URL pathname, req.path (ssr) or windows.location.pathname (client)
  docSpace?: ClientDocSpace; // The current docSpace
  docLeaf?: ClientDocLeaf; // The current docLeaf
  tagSet?: SDM.TagSet;
  toc?: Anchor[];
  versionsHistory?: VersionsHistory;
  editLink?: string;
}

export const PageContext = createContext<PageContextState>({
  isStatic: false,
  pdfMode: false,
  spacePdfExists: false,
  relPath: '.',
  docSpace: undefined,
  docLeaf: undefined,
  tagSet: undefined,
  pathname: '',
  toc: undefined,
  editLink: '',
  leafPdfExists: false,
});

interface CollectionPageContextState {
  items: CollectionItem[];
}

export const CollectionPageContext = createContext<CollectionPageContextState>({
  items: [],
});
